import { Icon } from '../Icon/Icon';
import { nb } from '@/i18n/nb';
import s from './Card.module.css';

type CardProps = {
  title: string;
  desc: string;
  /** Renders a lock badge + dimmed styling (guest-gated cards). Iter 3 wires the gating. */
  locked?: boolean;
  onClick?: () => void;
};

// Text-only cards (title + desc) — no module symbol, matching the canonical
// design kit (GATE 1 defect 01). Title/desc are spans, not headings —
// interactive elements shouldn't contain heading roles.
export function Card({ title, desc, locked = false, onClick }: CardProps) {
  return (
    <button type="button" className={`${s.card} ${locked ? s.locked : ''}`} onClick={onClick}>
      {locked && (
        <>
          <Icon name="lock" size={18} className={s.lock} />
          <span className="sr-only">{nb.modules.comingSoon}</span>
        </>
      )}
      <span>
        <span className={s.title}>{title}</span>
        <span className={s.desc}>{desc}</span>
      </span>
    </button>
  );
}
